import React, { memo, FC } from "react";
import Svg from "./Svg";
import colors from "../../utils/colorConstants";

interface Props {
  className?: string;
  height: string;
  strokeColor?: string;
  width: string;
}

const Palette: FC<Props> = ({
  className,
  height = "1.5rem",
  strokeColor = colors.lapel,
  width = "1.5rem",
}) => (
  <Svg
    className={className}
    height={height}
    viewBox="0 0 32 32"
    width={width}
    title="palette icon"
  >
    <path
      fill={strokeColor}
      d="M16 2.5h.31c7.3.17 13.19 6.16 13.19 13.5 0 .95-.16 2.03-.45 3.04l-.11.38-.4 1-.13.27-.01.03c-1.33 2.48-3.62 3.73-6.76 3.73-.36 0-.74-.01-1.13-.05l-.4-.04a6.73 6.73 0 00-.72-.04c-.7 0-.98.13-1.03.24-.04.06 0 .25.08.33.93 1.04 1.32 2.1 1 3.02-.22.7-.81 1.22-1.8 1.47l-.23.04-.06.01A13.52 13.52 0 012.5 16C2.49 8.66 8.38 2.67 15.68 2.5H16zm0 1h-.3C8.93 3.67 3.5 9.21 3.5 16a12.52 12.52 0 0013.42 12.47l.3-.03h.02c.77-.15 1.13-.45 1.26-.85.17-.51-.09-1.24-.8-2.03-.33-.36-.48-.99-.23-1.46.25-.49.87-.78 1.92-.78.2 0 .4 0 .62.02l.22.03c.5.05.96.08 1.41.08 2.68 0 4.59-1 5.76-2.99l.14-.26.1-.19.35-.93c.33-1 .51-2.12.51-3.08 0-6.79-5.44-12.33-12.2-12.5H16zm-7.5 12h.18a3 3 0 01-.18 6 3 3 0 01-.18-6h.18zm0 1h-.15a2 2 0 00.15 4 2 2 0 00.15-4H8.5zm2-9h.18a3 3 0 01-.18 6 3 3 0 01-.18-6h.18zm0 1h-.15a2 2 0 00.15 4 2 2 0 00.15-4h-.15zm8-3h.18a3 3 0 01-.18 6 3 3 0 01-.18-6h.18zm0 1h-.15a2 2 0 00.15 4 2 2 0 00.15-4h-.15z"
    />
  </Svg>
);

export default memo(Palette);
